<script setup lang="ts">
import { RouterView } from 'vue-router'
import { useAuthStore } from '@/stores/auth'
import AppSidebar from '@/components/navigation/AppSidebar.vue'
import HeaderBreadcrumb from '@/components/navigation/HeaderBreadcrumb.vue'
import { SidebarProvider, SidebarTrigger, SidebarInset } from '@/components/shadcn-ui/sidebar'
import { Separator } from '@/components/shadcn-ui/separator'

const authStore = useAuthStore()
</script>

<template>
  <SidebarProvider v-if="authStore.isAuthenticated">
    <AppSidebar />
    <SidebarInset>
      <header
        class="bg-background sticky top-0 z-10 flex h-16 shrink-0 items-center gap-2 border-b px-4"
      >
        <SidebarTrigger class="-ml-1" />
        <Separator orientation="vertical" class="mr-2 data-[orientation=vertical]:h-4" />
        <HeaderBreadcrumb />
      </header>
      <main class="p-5">
        <RouterView />
      </main>
    </SidebarInset>
  </SidebarProvider>

  <RouterView v-else />
</template>
